var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modalPhotoclaim",
    {
      ref: "modalPhotoclaimForm",
      attrs: { type: "full", closeIsHidden: _vm.loading },
      on: { "modal:close": _vm.resetForms, "modal:flash": _vm.handlerFlash },
    },
    [
      _c(
        "template",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          slot: "modalContent",
        },
        [
          _c(
            "div",
            { staticClass: "modal__main view" },
            [
              _c("ma-notifications"),
              _c("div", { staticClass: "view_content photoclaim_content" }, [
                _c("div", { staticClass: "photoclaim-component" }, [
                  _c("div", { staticClass: "photoclaim-component__video" }, [
                    _c("div", { staticClass: "video__output" }, [
                      _vm.takingPhoto
                        ? _c("div", { staticClass: "video-spinner" }, [
                            _c("div", { staticClass: "loader-spinner" }),
                          ])
                        : _vm._e(),
                      !_vm.takingPhoto
                        ? _c("div", { staticClass: "video-guide" }, [
                            _c("div", {
                              staticClass: "guide__box guide__box--top-left",
                            }),
                            _c("div", {
                              staticClass: "guide__box guide__box--top-right",
                            }),
                            _c("div", {
                              staticClass: "guide__box guide__box--bottom-left",
                            }),
                            _c("div", {
                              staticClass:
                                "guide__box guide__box--bottom-right",
                            }),
                          ])
                        : _vm._e(),
                      _c("video", {
                        ref: "video",
                        attrs: { autoplay: "", playsinline: "" },
                      }),
                    ]),
                    _c("div", { staticClass: "video__footer" }, [
                      _c("div", { staticClass: "video-footer__controls" }, [
                        _c(
                          "div",
                          { staticClass: "containerFileImg" },
                          [
                            _c("svgicon", {
                              attrs: {
                                name: "camera-create",
                                color: "#566473",
                                width: "24",
                                height: "24",
                              },
                            }),
                            _c("input", {
                              staticClass: "file text-medium-light",
                              attrs: {
                                type: "file",
                                accept: ".jpg, .jpeg, .png",
                                disabled: _vm.takingPhoto,
                              },
                              on: { change: _vm.handleChangeInput },
                            }),
                          ],
                          1
                        ),
                        _c("div", {
                          staticClass: "video-capture",
                          on: { click: _vm.takePhoto },
                        }),
                        _c(
                          "button",
                          {
                            ref: "buttonFlip",
                            staticClass: "change-camera",
                            on: { click: _vm.flipCamera },
                          },
                          [
                            _c("svgicon", {
                              attrs: {
                                name: "ico-switch",
                                color: "#566473",
                                height: "24",
                                width: "auto",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "video-footer__description" }, [
                        _c("h3", [_vm._v(_vm._s(_vm.literalDamagePart))]),
                        _c("p", [
                          _vm._v(
                            "Cliquez sur le bouton blanc pour capturer les dégâts. Nous avons besoin que vous preniez une photo en gros plan pour obtenir plus de détails sur les dégâts."
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm.loading
        ? _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main has-modal" },
              [_c("maSpinner", { staticClass: "spinner" })],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }